// Module
var code = "<protective-equipment-grid on-select=\"onEquipmentSelected($event)\" on-remove=\"onEquipmentRemove($event)\"></protective-equipment-grid>\n";
// Exports
module.exports = code;